export default __webpack_public_path__ + "static/media/login.f9d0c7db.png";